import React from "react";
import { Navigate } from "react-router-dom";


// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages PreDrf
// import PreDrf from "../pages/PreDrf/PreDrf";


// Pages Users
import Users from "../pages/Users/Users";

// pages Add User
import AddUser from "pages/AddUser/AddUser";

// Pages Brand

import Products from "../pages/Addproduct/Products";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartistChart from "../pages/Charts/ChartistChart";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";
import ChartsKnob from "../pages/Charts/charts-knob";
import ReCharts from "../pages/Charts/ReCharts";


// //Projects
import ProjectsGrid from "../pages/Projects/projects-grid";
import ProjectsList from "../pages/Projects/projects-list";
import ProjectsOverview from "../pages/Projects/ProjectOverview/projects-overview";
import ProjectsCreate from "../pages/Projects/projects-create";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailBasicTemplte from "../pages/Email/email-basic-templte";
import EmailAlertTemplte from "../pages/Email/email-template-alert";
import EmailTemplateBilling from "../pages/Email/email-template-billing";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import ForgetPwd2 from "../pages/AuthenticationInner/ForgetPassword2";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";
// import Editdrf from "pages/Editdrf/Editdrf";


// Dashboard
import Dashboard from "../pages/Dashboard/index";

import AddRole from "pages/AddUser/AddRole";

import Region from "pages/Region/Region";
import AddRegion from "pages/Region/AddRegion";

import Ward from "pages/Region/Ward";
import AddWard from "pages/Region/AddWard";
import AddFramesStocks from "pages/Frames/AddFramesStocks";
import AddFrameMaster from "pages/Frames/AddFrameMaster";
import FrameMaster from "pages/Frames/FrameMaster";

import Managepermission from "pages/Permission/Managepermission";

import Addpatient from "pages/Addpatient/Addpatient";
import Patient from "pages/Addpatient/Patient";

import Addclinic from "pages/Addclinic/Addclinic";
import Clinic from "pages/Addclinic/Clinic";

import Jobform from "pages/Jobform/Jobform";
import Job from "pages/Jobform/Job";

import Addvisit from "pages/Addvisit/Addvisit";
import Visit from "pages/Addvisit/Visit";

import Addstream from "pages/Addvisit/Addstream";
import Stream from "pages/Addvisit/Stream";

import Addvisit_type from "pages/Addvisit/Addvisit_type";
import Visit_type from "pages/Addvisit/Visit_type";

import Addrefferedby from "pages/Addvisit/Addrefferedby";
import Refferedby from "pages/Addvisit/Refferedby";

import Addrecord from "pages/Addvisit/Addrecord";
import Record from "pages/Addvisit/Record";
import PatientDetails from "pages/Addpatient/PatientDetails";
//Contacts
// auths
// bks ----
import Addlaborder from "pages/AddLab/Addlaborder";
import ViewLab from "pages/AddLab/LabOrderList";
import LabDetails from "pages/AddLab/LabDetails";
import Addpatientcare from "pages/Addpatientcare/Addpatientcare";
import ViewPatientcare from "pages/Addpatientcare/ViewPatientcare";
import FullviewPatientcare from "pages/Addpatientcare/FullviewPatientcare";
import Audittrial from "pages/AuditTrial/Audittrial";
import LensOrder from "pages/LensOrder/LensOrder";
import Vision from "pages/Vision/Vision";
import Vision_type from "pages/Vision/Vision_type";
import Vision_type_list from "pages/Vision/Vision_type_list";
import AddMedprovider from "pages/Medprovider/AddMedprovider";
import Medprovider from "pages/Medprovider/Medprovider";
import Fullviewjobform from "pages/Jobform/Fullviewjobform";
import GuestPermission from "pages/GuestPermission/GuestPermission";
import Invoice from "pages/Invoice/Invoice";
import ListInvoice from "pages/ListInvoice/ListInvoice";
import Viewinvoice from "pages/Viewinvoice/Viewinvoice";
import Onlineorder from "pages/AddLab/Onlineorder";
import Invoice_new from "pages/Invoice/Invoice_new";
import AddLens from "pages/Lens/AddLens";
import AddLensStock from "pages/Lens/AddLensStock";
import Lens from "pages/Lens/Lens";
import LensStock from "pages/Lens/LensStock";
import AddPlan from "pages/Plan/AddPlan";
import Accounts from "pages/Accounts/Accounts";
import AccountsTab from "pages/Accounts/AccountsTab";
import InvoiceTab from "pages/Accounts/InvoiceTab";
import PaymentsTab from "pages/Accounts/PaymentsTab";
import ViewInoice from "pages/Accounts/ViewInoice";
import SearchAccount from "pages/Accounts/SearchAccount";
import PaperRA from "pages/Accounts/PaperRA";
import MedicalInsurers from "pages/Accounts/MedicalInsurers";
import SuspenseAccount from "pages/Accounts/SuspenseAccount";
import Recollection from "pages/Accounts/Recollection";
import AddAppointment from "pages/Appointment/AddAppointment";
import AppointmentDetails from "pages/Appointment/AppointmentDetails";
import AppointmentList from "pages/Appointment/AppointmentList";
import Editclinic from "pages/Addclinic/Editclinic";
import Updatepatient from "pages/Addpatient/Updatepatient";
import TakeFrames from "pages/Addpatientcare/TakeFrames";
import TakeLenses from "pages/Addpatientcare/TakeLenses";
import ClinicSchedule from "pages/Addclinic/ClinicSchedule";
import Listtakeframe from "pages/Addpatientcare/Listtakeframe";
import Listtakelens from "pages/Addpatientcare/Listtakelens";
import ViewFrametaken from "pages/Addpatientcare/ViewFrametaken";
import ViewLenstaken from "pages/Addpatientcare/ViewLenstaken";
import AddGuestClinic from "pages/Addclinic/AddGuestClinic";




const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  //PreDrf
  { path: "/Products", component: <Products /> },

  //Users
  { path: "/Users", component: <Users /> },

  //Add User
  { path: "/AddUser", component: <AddUser /> },
  { path: "/user_role", component: <AddRole /> },

  { path: "/region", component: <Region /> },
  { path: "/add_region", component: <AddRegion /> },

  { path: "/ward", component: <Ward /> },
  { path: "/add_ward", component: <AddWard /> },

  { path: "/manage_permission", component: <Managepermission /> },

  { path: "/Addpatient", component: <Addpatient /> },
  { path: "/patient", component: <Patient /> },
  { path: "/update-patient/:id", component: <Updatepatient /> },
  { path: "/patientDetails/:id", component: <PatientDetails /> },

  { path: "/Addclinic", component: <Addclinic /> },
  { path: "/clinic", component: <Clinic /> },

  { path: "/addJobform", component: <Jobform /> },
  { path: "/job", component: <Job /> },
  { path: "/Fullviewjobform/:id", component: <Fullviewjobform /> },


  { path: "/Addvisit", component: <Addvisit /> },
  { path: "/Addvisit/:id", component: <Addvisit /> },
  { path: "/visit", component: <Visit /> },

  { path: "/Addstream", component: <Addstream /> },
  { path: "/stream", component: <Stream /> },

  { path: "/Addvisit_type", component: <Addvisit_type /> },
  { path: "/visit_type", component: <Visit_type /> },

  { path: "/Addrefferedby", component: <Addrefferedby /> },
  { path: "/refferedby", component: <Refferedby /> },

  { path: "/Addrecord", component: <Addrecord /> },
  { path: "/record", component: <Record /> },
  { path: "/frames", component: <AddFramesStocks /> },
  { path: "/addframes", component: <AddFrameMaster /> },
  { path: "/FrameMaster", component: <FrameMaster /> },
  { path: "/takeframe", component: <TakeFrames /> },
  { path: "/takelense", component: <TakeLenses /> },
  { path: "/list-takeframe", component: <Listtakeframe /> },
  { path: "/view-takeframe/:id", component: <ViewFrametaken /> },
  { path: "/list-takelens", component: <Listtakelens /> },
  { path: "/view-takelens/:id", component: <ViewLenstaken /> },

  // LensStock
  { path: "/LensStock", component: <AddLensStock /> },
  { path: "/LensStocklist", component: <LensStock /> },

  // Lens
  { path: "/addlens", component: <AddLens /> },
  { path: "/lens", component: <Lens /> },
  { path: "/ClinicSchedule/:clinicId", component: <ClinicSchedule /> },
  // { path: "/ClinicSchedule", component: <ClinicSchedule /> },
  // bk --

  // AddLab
  { path: "/LensOrder", component: <LensOrder /> },
  { path: "/Addlab", component: <Addlaborder /> },
  { path: "/labOrderList", component: <ViewLab /> },
  { path: "/labDetails/:id", component: <LabDetails /> },
  { path: "/Addpatientcare", component: <Addpatientcare /> },
  { path: "/ViewPatientcare", component: <ViewPatientcare /> },
  { path: "/FullviewPatientcare/:id", component: <FullviewPatientcare /> },
  { path: "/vision", component: <Vision /> },
  { path: "/Vision_type", component: <Vision_type /> },
  { path: "/Vision_type_list", component: <Vision_type_list /> },



  { path: "/med_provider", component: <AddMedprovider /> },
  { path: "/med_provider_list", component: <Medprovider /> },

  //profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/Audittrial", component: <Audittrial /> },
  { path: "/invoice", component: <Invoice /> },
  { path: "/accounts", component: <Invoice_new /> },
  { path: "/list/invoice", component: <ListInvoice /> },
  { path: "/view/invoice/:id", component: <Viewinvoice /> },
  { path: "/plan", component: <AddPlan /> },

  // practice-accounts
  { path: "/practice-accounts", component: <Accounts /> },
  { path: "/accounts-tab", component: <AccountsTab /> },
  { path: "/invoice-tab", component: <InvoiceTab /> },
  { path: "/payments-tab", component: <PaymentsTab /> },
  { path: "/ViewInoice", component: <ViewInoice /> },
  { path: "/SearchAccount", component: <SearchAccount /> },
  { path: "/PaperRA", component: <PaperRA /> },
  { path: "/MedicalInsurers", component: <MedicalInsurers /> },
  { path: "/SuspenseAccount", component: <SuspenseAccount /> },
  { path: "/Recollection", component: <Recollection /> },

  // Appointment
  { path: "/Appointment", component: <AddAppointment /> },
  { path: "/AppointmentList", component: <AppointmentList /> },
  { path: "/AppointmentDetails/:id", component: <AppointmentDetails /> },
  { path: "/Editclinic/:id", component: <Editclinic /> },



  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-template-basic", component: <EmailBasicTemplte /> },
  { path: "/email-template-alert", component: <EmailAlertTemplte /> },
  { path: "/email-template-billing", component: <EmailTemplateBilling /> },

  //Projects
  { path: "/projects-grid", component: <ProjectsGrid /> },
  { path: "/projects-list", component: <ProjectsList /> },
  { path: "/projects-overview", component: <ProjectsOverview /> },
  { path: "/projects-overview/:id", component: <ProjectsOverview /> },
  { path: "/projects-create", component: <ProjectsCreate /> },


  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: < Navigate to="/dashboard" />,
  },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/GuestPermission", component: <GuestPermission /> },
  { path: "/new-guest-practice", component: <AddGuestClinic /> },
  { path: "/order-online/:id", component: <Onlineorder /> },
  // { path: "/forgot-password", component: <ForgetPwd /> },
  // { path: "/register", component: <Register /> },
  // { path: "/ManufacturePredrf/:id", component: <ManufacturePredrf /> },
  // { path: "/Successsubmitpredrf", component: <Successsubmitpredrf /> },



  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-recoverpw-2", component: <ForgetPwd2 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartist-charts", component: <ChartistChart /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },
  { path: "/charts-knob", component: <ChartsKnob /> },
  { path: "/re-charts", component: <ReCharts /> },
];

export { authProtectedRoutes, publicRoutes };
